/**
 * @author PoornaChandu
 * @description This Code is for query building
 */

import React from 'react';
import { Select, Input, Row, Col } from 'antd';

const { Option } = Select;

const operators = ['=', '!=', '<', '>', '<=', '>='];

const Rule = ({ rule }) => {
  const getStatusValue = () => {
    if (rule.result === true)
      return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '3px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: 'green',
              marginRight: '8px'
            }}
          />
          <span style={{ fontWeight: 'bold', color: 'green' }}>SATISFIED</span>
        </div>
      );
    if (rule.result === false)
      return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '3px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: 'red',
              marginRight: '8px'
            }}
          />
          <span style={{ fontWeight: 'bold', color: 'red' }}>NOT SATISFIED</span>
        </div>
      );
  };

  return (
    <Row
      gutter={16}
      style={{
        marginBottom: 8,
        display: 'flex',
        padding: '8px',
        borderRadius: '5px',
        alignItems: 'middle'
      }}
    >
      <Col span={5}>
        <Input
          placeholder="Tag"
          value={rule.tag}
          readOnly
          style={{
            width: '100%',
            backgroundColor: '#e9ecef',
            color: '#000000',
            cursor: 'not-allowed'
          }}
        />
      </Col>
      <Col span={5}>
        <Select
          disabled
          value={rule.operator}
          style={{
            width: '100%',
            backgroundColor: '#e9ecef',
            cursor: 'not-allowed'
          }}
          dropdownStyle={{ borderRadius: '4px' }}
        >
          {operators.map((op) => (
            <Option key={op} value={op}>
              {op}
            </Option>
          ))}
        </Select>
      </Col>
      <Col span={5}>
        <Input
          placeholder="Value"
          value={rule.value}
          readOnly
          style={{
            width: '100%',
            backgroundColor: '#e9ecef',
            color: '#000000',
            cursor: 'not-allowed'
          }}
        />
      </Col>
      <Col span={5}>{getStatusValue()}</Col>
    </Row>
  );
};

const ManualRule = ({ rule }) => {
  return (
    <Row gutter={16} style={{ marginBottom: 8 }}>
      <Col span={24}>
        <Input.TextArea
          placeholder="Manual"
          value={rule.text}
          readOnly
          rows={2}
          style={{
            maxWidth: '62%',
            borderColor: '#fff',
            borderRadius: '4px',
            backgroundColor: '#e9ecef',
            color: '#000000',
            cursor: 'not-allowed',
            boxShadow: '0px 2px 2px rgba(255,255,255,0.5)'
          }}
        />
      </Col>
    </Row>
  );
};

const RuleGroup = ({ group }) => {
  return (
    <div
      style={{
        border: '1px solid #ffffff',
        padding: 16,
        marginBottom: 16,
        borderRadius: '8px',
        boxShadow: '0px 4px 8px rgba(0,0,0,0.1)'
      }}
    >
      {group.rules &&
        group.rules.map((rule, index) => (
          <React.Fragment key={index}>
            {rule.logicalOperator ? (
              <RuleGroup group={rule} />
            ) : rule.type === 'manual' && rule.text?.length > 0 ? (
              <ManualRule rule={rule} />
            ) : rule.type !== 'manual' ? (
              <Rule rule={rule} />
            ) : null}
            {index < group.rules.length - 1 && !rule.logicalOperator && (
              <div
                style={{
                  textAlign: 'left',
                  
                  marginBottom: '12px',
                  color: '#1890ff'
                }}
              >
                <strong>{group.logicalOperator}</strong>
              </div>
            )}
          </React.Fragment>
        ))}
    </div>
  );
};

const Querybuilder = ({ queryData }) => {
  if (queryData === undefined) {
    return null;
  } else {
    return (
      <div style={{ padding: 24 }}>
        <RuleGroup group={queryData} />
      </div>
    );
  }
};

export default Querybuilder;
